import type { NewsArticle } from './newsData';

export const newsArchive2021: NewsArticle[] = [
  {
    slug: 'information-session-consultation-202103',
    date: '2021年3月8日',
    category: 'update',
    categoryLabel: '実技指導',
    title: '所作訓練で最初に詰まる三つの動作——現場指導で見えた乗り越え方',
    metaDescription:
      '立ち方・盆の運び・扉前の一礼など、執事の所作訓練で初学者がつまずきやすい点を実技指導の視点から整理。定員6名の少人数制でどう矯正し、身体に定着させるかを具体的に解説します。',
    keywords: ['所作訓練', '執事の立ち居振る舞い', '実技指導', 'つまずきやすい点', '少人数制レッスン'],
    heroImage: '/images/generated/training-basic-2026.jpg',
    heroAlt: '基礎の立ち居振る舞いを反復確認する実技指導の場面',
    figures: [
      {
        src: '/images/generated/essential-manners-2026.jpg',
        alt: '手の位置と視線を整える所作練習の手元',
        caption: '最初のつまずきは「速さ」より「静止の質」に出やすい',
      },
    ],
    overview: {
      heading: '所作訓練で扱う初学者の課題',
      rows: [
        { label: '主な対象', value: 'エッセンシャル受講初期の実技' },
        { label: '指導形態', value: '定員6名・最少催行3名の対面実技' },
        { label: '1日の構成', value: '90分×4コマ（計6時間）' },
        { label: '開催', value: '土日中心／お台場本校' },
        { label: '到達の目安', value: '静止・移動・受け渡しの型が崩れないこと' },
      ],
    },
    faq: [
      {
        question: '最初にいちばん多いつまずきは何ですか？',
        answer:
          '静止したときの重心のブレです。肩に力が入り、膝がロックされると、次の一歩や一礼の角度が安定しません。まず「止め方」を分解して練習します。',
      },
      {
        question: '独学の鏡練習だけでは足りない理由は？',
        answer:
          '鏡は正面の印象はつかめますが、側面の背筋や盆を持ったときの肘の開きは見えにくいためです。少人数制では講師が斜め後方からも修正します。',
      },
      {
        question: '上達が遅いと感じたときの対処は？',
        answer:
          '動作を速くつなげる前に、各静止点で呼吸を一度置く練習に戻します。出席率80％以上を目安に反復し、修了実技試験前に型を再点検します。',
      },
    ],
    related: [
      { title: 'カリキュラム', desc: '実技と座学の配分を確認', href: '/curriculum' },
      { title: 'コース一覧', desc: 'エッセンシャルからの学び方', href: '/courses' },
      { title: '修了・認定について', desc: '実技試験の位置づけ', href: '/certificate' },
      { title: '説明会・体験講座', desc: '動作の雰囲気を先に知る', href: '/seminar' },
    ],
    body: `<p>実技の初回から数回にかけて、受講生の多くが同じ箇所で足踏みをします。速さや華やかさではなく、「止まった瞬間の静けさ」が崩れることです。本稿では、お台場本校の指導現場で繰り返し観察してきたつまずきと、そのとき講師が取る介入の順序を共有します。</p>
<h2>つまずき①　静止した瞬間の重心</h2>
<p>来客を迎える前の立ち位置で、かかとに体重が残り、肩がすくむケースが目立ちます。この状態だと一礼の深さが日によって変わり、視線の置き場も定まりません。指導では、足裏のどこに体重があるかを言葉にしてもらい、膝をわずかに柔らげた位置で三呼吸置く練習から入ります。定員6名のため、一人ずつ側面から確認できるのが少人数制の利点です。</p>
<h2>つまずき②　盆・トレイを持った肘の開き</h2>
<p>空手が整っても、器具を持つと肘が外へ張り、歩幅が急に短くなることがあります。原因の多くは「落とさない」意識が肩甲骨を固めることにあります。90分コマの前半で重さの感覚だけを取り、後半で短い動線を歩く、という二段に分けると再現性が上がります。最少催行3名以上のクラスでも、動線をずらして同時に観察できるよう床面の目印を使います。</p>
<h2>つまずき③　扉前・角での間の取り方</h2>
<p>廊下から部屋へ入る直前、歩調が速くなり一礼が浅くなる現象です。頭では順序を理解していても、身体が「先に進みたい」と反応します。ここでは動作を三つに切り、停止・礼・進入を別々に計測してから再結合します。土日の1日6時間（90分×4コマ）のうち、最終コマは朝の自分の映像やメモと見比べる振り返りに充て、翌日以降の自宅練習の焦点を一つに絞ります。</p>
<h2>乗り越えを早める現場の工夫</h2>
<p>指摘を一度に増やさないこと、できた静止を短く言語化して残すこと、そして「速さの課題」と「型の課題」を混ぜないことが柱です。修了実技試験は型の安定を見る場であり、再試験は1回無料で受けられます。焦って手順を増やすより、同じ三動作を丁寧に重ねる方が、結果として試験直前の修正量が減ります。所作は才能の勝負ではなく、観察と反復の設計の問題です。</p>`,
  },
  {
    slug: 'three-courses-opening-guidance-202107',
    date: '2021年7月12日',
    category: 'update',
    categoryLabel: '教材解説',
    title: '全15冊はなぜモジュール型か——学ぶ順序とコース横断の使い方',
    metaDescription:
      '教科書全15冊をモジュール式にした意図と、エッセンシャルからマスターまでどの順で開くべきかを解説。座学と実技の往復、章の依存関係、自宅学習での参照の仕方まで具体的に示します。',
    keywords: ['教科書全15冊', 'モジュール式教材', '学ぶ順序', '執事コース教材', '座学と実技'],
    heroImage: '/images/generated/essential-writing-2026.jpg',
    heroAlt: 'モジュールごとに整理された教科書と筆記用具が並ぶ机上',
    figures: [
      {
        src: '/images/generated/about-classroom-2026.jpg',
        alt: '教材を開きながら進行する少人数講義の教室',
        caption: '章単体で完結しつつ、後続モジュールへ橋を渡す構成',
      },
    ],
    overview: {
      heading: 'モジュール式教科書の設計概要',
      rows: [
        { label: '冊数', value: '全15冊' },
        { label: '対応課程', value: 'エッセンシャル／アドバンス／マスター' },
        { label: '設計思想', value: '単元完結＋依存順の明示' },
        { label: '授業との関係', value: '90分コマごとに参照箇所を指定' },
        { label: '評価との接続', value: '修了実技試験の観点と章末確認が対応' },
      ],
    },
    faq: [
      {
        question: '15冊を最初から通読する必要はありますか？',
        answer:
          '不要です。依存関係の浅い基礎モジュールから、その日の実技に必要な章だけを開く運用を推奨しています。通読は復習フェーズで十分です。',
      },
      {
        question: 'コースが上がると前の冊子は使わなくなりますか？',
        answer:
          'いいえ。上位コースでも基礎モジュールを参照して型を再確認します。アドバンス以降は応用冊子が主教材になり、基礎は辞書的に使います。',
      },
      {
        question: '章末の確認問題は試験そのものですか？',
        answer:
          '試験問題の複製ではありません。修了実技試験で見られる観点——順序・間・安全——を文章と図で先に意識するためのものです。',
      },
    ],
    related: [
      { title: '教材紹介', desc: '全15冊の位置づけ', href: '/materials' },
      { title: 'カリキュラム', desc: 'モジュールと日程の対応', href: '/curriculum' },
      { title: 'コース一覧', desc: '3コースの到達点', href: '/courses' },
      { title: '資料請求（無料）', desc: '構成の概要を手元で確認', href: '/brochure' },
    ],
    body: `<p>当校の教科書は、一冊で物語のように読み進める長編ではなく、役割の異なる15のモジュールとして編んであります。理由は単純で、実技の習得が「必要な知識だけを、必要なタイミングで」取り出す作業だからです。2021年度の運用にあたり、学ぶ順序の考え方を改めて文章化します。</p>
<h2>モジュールに分ける三つの利点</h2>
<p>第一に、改訂が局所で済むこと。接遇の用語や銀器の扱い手順が更新されても、関連冊子だけを差し替えられます。第二に、受講生の既習差を吸収しやすいこと。社会人経験のある方は基礎の一部を短時間で通過し、手薄な単元に時間を回せます。第三に、90分×4コマの1日6時間のなかで、午前に理論・午後に身体、という往復が章単位で指示できることです。</p>
<h2>推奨する開き方——依存の浅い順</h2>
<p>最初に触れるのは、姿勢・歩行・声の出し方など、すべての応対に効く土台モジュールです。そのうえで来客の迎え、室内案内、茶や水の提供といった単機能の手順へ進みます。テーブルサービスや場面判断の冊子は、土台と単機能が口に馴染んでから開きます。エッセンシャルではこの前半群が中心になり、アドバンスで複合場面、マスターで家政管理や長期運用の判断モジュールが加わります。</p>
<h2>教室と自宅での役割分担</h2>
<p>教室（定員6名・最少催行3名）では、講師が「今日見る章」と「触らない章」を明示します。自宅では、できなかった動作に紐づく数ページだけを読み、翌日の実技前に要点を音読する使い方を勧めています。全頁を線で埋める必要はなく、自分の失敗パターンにタグを付ける方が定着が速い、というのが現場の感触です。</p>
<h2>試験・資格とのつなぎ</h2>
<p>修了実技試験の観点は、モジュール末尾の確認項目と対応づけてあります。協会認定資格の授与は、所定の出席率（80％以上）と実技基準を満たした方が対象です。再試験は1回無料ですので、不合格時は該当モジュールに戻って穴を特定する運用が可能です。15冊は量を誇るためのものではなく、学びの地図を細かく折りたたんだ結果です。迷ったときは「今の実技の直前に必要な一冊」から開いてください。</p>`,
  },
  {
    slug: 'materials-curriculum-update-202111',
    date: '2021年11月15日',
    category: 'schedule',
    categoryLabel: '施設・環境',
    title: 'サロン・食器・銀器で進めるお台場本校の実習——一日の流れを公開',
    metaDescription:
      'お台場本校のサロン空間と食器・銀器を使った実習が、90分×4コマの一日でどう進むのかを紹介。少人数定員6名ならではの動線設計、安全確認、振り返りの付け方まで現場目線でまとめました。',
    keywords: ['お台場本校', 'サロン実習', '銀器の扱い', '食器セッティング', '執事実技授業'],
    heroImage: '/images/generated/facilities-hero-2026.jpg',
    heroAlt: '実習に備えて整えられたお台場本校のサロン空間',
    figures: [
      {
        src: '/images/generated/advanced-service-2026.jpg',
        alt: '食器と銀器を用いたテーブルサービスの実技演習',
        caption: '実物の重さと間隔でしか学べない感覚を一日に組み込む',
      },
    ],
    overview: {
      heading: 'お台場本校実習の運営要点',
      rows: [
        { label: '会場', value: 'お台場本校サロンおよび実習スペース' },
        { label: '使用機材', value: '食器一式・銀器・サーヴィステーブル' },
        { label: '定員', value: '6名（最少催行3名）' },
        { label: '時間割', value: '土日／1日6時間（90分×4コマ）' },
        { label: '安全', value: '破損・火傷・動線交差の事前確認' },
      ],
    },
    faq: [
      {
        question: '最初から銀器を使いますか？',
        answer:
          '初回は重量の近い練習用から入り、持ち方と静音が安定した段階で本番の銀器へ移行します。焦って実物に触れるより、段階を踏む方が破損リスクも下がります。',
      },
      {
        question: '服装や手の準備で必要なことは？',
        answer:
          '爪・香り・アクセサリーなど、器に触れる前提の身だしなみを授業冒頭で点検します。詳細は入学後の案内と当日のブリーフィングで共有します。',
      },
      {
        question: '見学だけで設備を見ることはできますか？',
        answer:
          '説明会や施設紹介の枠で動線の概要をお伝えできます。実習そのものの体験は、安全と定員の都合上、受講または指定の体験枠での対応となります。',
      },
    ],
    related: [
      { title: 'アクセス', desc: 'お台場本校への行き方', href: '/access' },
      { title: 'カリキュラム', desc: '実習コマの組み方', href: '/curriculum' },
      { title: '受講料金', desc: 'コースごとの費用', href: '/pricing' },
      { title: 'お問い合わせ', desc: '施設利用に関する質問', href: '/contact' },
    ],
    body: `<p>座学で手順を覚えても、床の感触や器の重心が変わると動きは別物になります。お台場本校では、サロンを模した空間に食器と銀器を配置し、来客応対からテーブルサービスまでの一連を「その場の距離感」で練習します。以下は、土日に組まれる典型的な一日の進め方です。</p>
<h2>コマ1　空間把握と静かな動線</h2>
<p>最初の90分は、家具の角・扉・窓際の光など、つまずきやすい地点の確認に使います。定員6名を一度に歩かせず、3名ずつに分けて交差が起きないルートを決めるのが基本です。最少催行3名の回でも、空いたスペースを「待機位置」として明示し、無駄な徘徊が癖にならないようします。</p>
<h2>コマ2　食器の配置と目視の基準</h2>
<p>プレート、グラス、カトラリーの間隔は、テキストの図だけでは身体に残りません。実物を並べ、腰の高さと視線の落とす位置を揃えたうえで、ずれを自分で測る習慣を付けます。音を立てない置き方、指の触れ面、布巾の隠し方など、写真に残りにくい細部をここで固定します。</p>
<h2>コマ3　銀器を含む提供の実技</h2>
<p>午後は重量と反射を伴う銀器を導入します。持ち替えの回数を減らす握り、トレイ上での滑り止め、提供前後の一拍の置き方を反復します。1日6時間のうちこのコマが最も集中力を要するので、途中で短い休憩と手指の状態チェックを挟み、安全を優先します。</p>
<h2>コマ4　通し演練と記録</h2>
<p>最終コマは、朝に決めた動線で短いシナリオを通します。講師は減点表のように指摘を並べるのではなく、次の自宅練習で直す一点を各人に渡します。出席率80％以上を維持しながら回を重ね、修了実技試験では同じサロン設備で一連の安定を確認します。協会認定資格の案内も、この実物環境での基準を満たした方へ行います。設備は見せるための装飾ではなく、判断を身体化する装置です。次回の実習日は、当日のメモで「音・間隔・停止」のどれを主眼にするかだけ決めてから臨むと、同じ部屋でも学びの密度が変わります。</p>`,
  },
  {
    slug: 'essential-spring-intake-202104',
    date: '2021年4月6日',
    category: 'schedule',
    categoryLabel: '開校情報',
    title: '未経験から型を積む春期エッセンシャル——4月開校クラスの日程と学び方',
    metaDescription:
      '2021年4月、お台場本校でエッセンシャルコース春期クラスを開校。未経験者向けに1ヶ月8日間48時間、土日・1日6時間で姿勢から応対の基礎を習得。定員6名・最少催行3名、申込締切と書類確認の流れを掲載します。',
    keywords: ['エッセンシャルコース', '2021年春期', '未経験者向け', '4月開校', 'お台場本校'],
    heroImage: '/images/generated/course-essential-2026.jpg',
    heroAlt: '春期エッセンシャルの初回に姿勢と立ち位置を確認する教室',
    figures: [
      {
        src: '/images/generated/admission-orientation-2026.jpg',
        alt: '開講前オリエンテーションで配布物と時間割を確認する様子',
        caption: '初回前に配布物と土日8日間の進行を共有する',
      },
    ],
    overview: {
      heading: '2021年春期エッセンシャル開校の要点',
      rows: [
        { label: '開校時期', value: '2021年4月（春期）' },
        { label: '対象コース', value: 'エッセンシャル（未経験者向け入門）' },
        { label: '期間・時間', value: '1ヶ月・8日間・48時間' },
        { label: '開催形態', value: '土日／1日6時間（90分×4コマ）／お台場本校' },
        { label: '定員', value: '6名（最少催行3名）' },
      ],
    },
    faq: [
      {
        question: '完全な未経験でも春期クラスに入れますか？',
        answer:
          'はい。エッセンシャルは前提資格を設けていません。初回は静止と歩行から入り、用語集も教科書全15冊のうち基礎モジュールで補います。',
      },
      {
        question: '申込はいつまでに何を提出しますか？',
        answer:
          '開講日の10日前までにWebフォーム送信後、本人確認書類の写しをメール添付してください。定員に達した時点で受付を閉じます。',
      },
      {
        question: '修了後に受け取れるものは何ですか？',
        answer:
          '出席率80％以上と修了実技試験の基準を満たした方へ、協会認定資格の申請案内をお渡しします。再試験は1回無料です。',
      },
    ],
    related: [
      { title: 'コース一覧', desc: 'エッセンシャルの到達点', href: '/courses' },
      { title: '入学案内', desc: '提出書類と手順', href: '/admission' },
      { title: '受講料金', desc: '春期の費用内訳', href: '/pricing' },
      { title: '資料請求（無料）', desc: '日程表を手元で確認', href: '/brochure' },
    ],
    body: `<p>2021年4月、お台場本校にてエッセンシャルコースの春期クラスを開校します。対象は接遇や家政の実務経験がない方、および基礎から型をやり直したい方です。期間は1ヶ月・8日間・48時間。すべて土日開催で、1日は90分×4コマの計6時間です。以下に日程の組み立て、教室での学び方、申込から開講までの流れをまとめます。</p>
<h2>春期クラスの日程と教室運営</h2>
<p>開講週から4週にわたり、土曜・日曜に連続して実施します。午前は姿勢・視線・声量など身体の土台、午後は来客の迎えと短い動線での受け渡しに充てます。定員6名、最少催行3名。欠席が出ても動線が崩れないよう、床面の待機位置を最初のコマで固定します。教科書全15冊のうち、春期は依存の浅い基礎モジュールを中心に参照し、その日の実技に必要な章だけを開く運用です。</p>
<h2>未経験者が最初の一ヶ月で触れる範囲</h2>
<p>エッセンシャルでは「速く美しく」より「止まって崩れない」ことを優先します。立ち位置の決め方、扉前の一礼、盆を持った肘の角度、言葉の区切り方を反復し、週末ごとに短い通し演練を入れます。自宅課題は長文レポートではなく、翌日までに直す一点をメモする形式です。出席率80％以上を目安に回を重ね、最終週に修了実技試験を行います。基準に届かなかった場合の再試験は1回無料です。</p>
<h2>申込の流れ——先着ではなく書類確認後の確定</h2>
<p>受付はWebフォームの到達順を起点にしますが、席の確定は本人確認書類の確認後です。開講10日前を提出期限とし、不備がある場合は期限までに差し替えをお願いします。定員に達した時点でフォームを閉じ、最少催行3名に満たない場合は開講可否をメールでご連絡します。説明会への事前参加は必須ではありませんが、教室の距離感を知りたい方はセミナー枠をご利用ください。</p>
<h2>開講までに用意してほしいこと</h2>
<p>動きやすい黒系の服装、爪の長さ、強い香りの自粛など、器や布に触れる前提の身だしなみを整えてください。詳細は受付完了メールに記載します。協会認定資格は修了要件を満たした方への案内となり、入学時点での保証ではありません。春期は「型の辞書を自分の身体に一冊分入れる」期間です。日程が合わない場合は次期の案内を個別にお送りしますので、フォームの希望欄にその旨をご記入ください。</p>`,
  },
  {
    slug: 'advance-autumn-cohort-202110',
    date: '2021年10月4日',
    category: 'recruitment',
    categoryLabel: '募集情報',
    title: '基礎修了者が複合応対へ進む——秋のアドバンス2ヶ月クラスを編成',
    metaDescription:
      '2021年10月開始のアドバンスコース秋期募集。エッセンシャル修了相当の方向けに2ヶ月12日間72時間、土日お台場本校でテーブルサービスと場面判断を強化。定員6名、面接確認後に席確定する手順を説明します。',
    keywords: ['アドバンスコース', '2021年秋期', '基礎修了者', '2ヶ月12日間', '複合応対'],
    heroImage: '/images/generated/course-advanced-2026.jpg',
    heroAlt: 'アドバンスクラスでテーブル周りの複合動線を練習する様子',
    figures: [
      {
        src: '/images/generated/master-table-2026.jpg',
        alt: '複数食器を扱う応用テーブルサービスの演習',
        caption: '単機能の型を、来客シナリオのなかで再結合する',
      },
    ],
    overview: {
      heading: '2021年秋期アドバンス募集の要点',
      rows: [
        { label: '開始時期', value: '2021年10月（秋期）' },
        { label: '対象コース', value: 'アドバンス（基礎修了者向け応用）' },
        { label: '期間・時間', value: '2ヶ月・12日間・72時間' },
        { label: '開催形態', value: '土日／1日6時間（90分×4コマ）／お台場本校' },
        { label: '定員・選考', value: '6名（最少催行3名）／簡易面接のうえ席確定' },
      ],
    },
    faq: [
      {
        question: 'エッセンシャルを他期で修了していれば応募できますか？',
        answer:
          'できます。修了時期が古くても、静止・一礼・基本の受け渡しが再現できるかを面接時に短く確認し、必要なら開始前の補習コマを案内します。',
      },
      {
        question: '秋期の締切と席の決め方を教えてください。',
        answer:
          '開始日の14日前に一次締切を設け、書類と面接が揃った方から席を確定します。欠員がある場合のみ、その後に追加受付を行います。',
      },
      {
        question: 'マスターとの違いは何ですか？',
        answer:
          'アドバンスは複合応対とテーブル周りの判断が中心です。マスターは3ヶ月16日間96時間で家政管理や長期運用の設計まで扱います。',
      },
    ],
    related: [
      { title: 'コース一覧', desc: 'アドバンスの位置づけ', href: '/courses' },
      { title: 'カリキュラム', desc: '12日間の単元配分', href: '/curriculum' },
      { title: '修了・認定について', desc: '実技試験と資格案内', href: '/certificate' },
      { title: 'お問い合わせ', desc: '面接枠の空き確認', href: '/contact' },
    ],
    body: `<p>2021年10月より、お台場本校でアドバンスコースの秋期クラスを編成します。対象はエッセンシャル修了者、または同等の基礎実技が示せる方です。期間は2ヶ月・12日間・72時間。土日のみ、1日6時間（90分×4コマ）で、単体の型を「来客シナリオのなかの複合動作」へつなぎ直します。春の入門期とは募集の締め方も異なり、書類に加え短い面接で席を確定します。</p>
<h2>秋期アドバンスで扱う学びの核</h2>
<p>前半4週はテーブルサービスと銀器を含む提供、複数名が同時に動く動線の調整に集中します。後半4週は、予定変更・来客の重なり・室内と廊下の切替えなど、判断が分岐する場面を短い台本で回します。教科書全15冊のうち応用モジュールを主教材とし、基礎冊子は辞書として机上に置きます。定員6名のため、一人がホスト役・他が観察役に回り、同じ場面を角度を変えて繰り返せます。最少催行は3名です。</p>
<h2>1日の進め方と自宅での接続</h2>
<p>90分コマの1つ目で観点を一つだけ提示し、2・3コマ目で実技、4コマ目で映像または相互メモによる振り返り、という型を崩しません。自宅課題は「失敗した分岐を一文で書く」ことに限定し、次の登校日の最初に共有します。出席率80％以上を維持したうえで期末に修了実技試験を実施し、協会認定資格の上位案内が可能な基準かも合わせて確認します。再試験は1回無料です。</p>
<h2>募集の締め方——一次締切と面接後確定</h2>
<p>Webフォーム受付ののち、開始14日前を一次締切とします。締切時点で書類が揃っている方に面接枠（遠隔可・15分程度）を割り当て、基礎動作の再現と学習時間の確保状況を確認してから席を確定します。定員到達後はキャンセル待ちのみ受け付け、欠員が出た場合に限り開始7日前まで追加連絡します。先着順のみで閉じないのは、応用期に必要な準備量に差が出るためです。</p>
<h2>受講前に揃えておくとよい準備</h2>
<p>エッセンシャル期のノートや、自分がつまずいた動作のメモがあれば持参してください。服装規定は入学案内に準じ、香りと爪、靴音の確認を初回冒頭で行います。料金と教材費の内訳は料金ページを参照し、不明点は面接前に問い合わせて差し支えありません。秋期は「できた型を、状況が変わっても保てるか」を問う八週間です。日程と面接枠の最新状況は、ページ下部の関連リンクから確認できます。</p>`,
  },
];
